import MenuGroupAPI from './menu-group-api';

export default MenuGroupAPI;
